import React, { useState, useEffect } from 'react';
import { selectorBeneficiosVt } from '@core/slice/beneficiosVt.slice';
import { useAppSelector } from '@store/hooks';
import { Box, Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { colaboradorService } from '@core/services';
import { ContentSeparator, LoadingView } from '@core/components';
import { AlertComponent } from '@core/components/atoms/alert-component';
import { TableCellStyled } from '@core/components/organisms/simple-table/styled';

interface IBeneficiosVt {}
export const Transporte: React.FC<IBeneficiosVt> = () => {
    const { data, loading, error } = useAppSelector(selectorBeneficiosVt);

    useEffect(() => {
        colaboradorService.beneficiosVt();
    }, []);

    return (
        <Container maxWidth="xl" sx={{ px: '2rem' }}>
            {loading && <LoadingView />}

            {error && !loading ? (
                <AlertComponent type="error" detailed={true} message={error ?? '-'} />
            ) : !loading ? (
                <>
                    <ContentSeparator title="LINHAS UTILIZADAS" />
                    <Box sx={{ width: '100%', marginTop: '2rem' }}>
                        <TableContainer sx={{ overflowX: 'auto' }} component={Paper}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCellStyled align="left">Cód.</TableCellStyled>
                                        <TableCellStyled align="left">Linha</TableCellStyled>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data ? (
                                        data.map((linha, index) => (
                                            <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell sx={{ whiteSpace: 'nowrap' }} align="left">
                                                    {linha.codlin}
                                                </TableCell>
                                                <TableCell sx={{ whiteSpace: 'nowrap' }} align="left">
                                                    {linha.nomlin}
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow key={0} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell sx={{ whiteSpace: 'nowrap' }} align="left">
                                                Não há linhas para exibir.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </>
            ) : (
                ''
            )}
        </Container>
    );
};
